const SOURCES = {
  hero: { src: "/mascot/spot.webp", srcSet: "/mascot/spot-sm.webp 316w, /mascot/spot.webp 633w", w: 633, h: 965 },
  wink: { src: "/mascot/spot-wink.webp", w: 307, h: 380 },
  walk: { src: "/mascot/spot-walk.webp", w: 296, h: 385 },
};

export const Spot = ({ variant = "hero", className = "", sizes, animate = true, eager = false, testId = "spot-mascot", alt = "Spot, la mascotte CAFÉ-SPOT" }) => {
  const s = SOURCES[variant];
  return (
    <img
      data-testid={testId}
      src={s.src}
      srcSet={s.srcSet}
      sizes={sizes}
      width={s.w}
      height={s.h}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      fetchPriority={eager ? "high" : undefined}
      decoding="async"
      draggable={false}
      className={`select-none ${animate ? "spot-breathe" : ""} ${className}`}
    />
  );
};

export const SpotLoader = ({ label = "Chargement", className = "" }) => (
  <div data-testid="spot-loader" role="status" aria-live="polite" className={`flex flex-col items-center justify-center gap-5 ${className}`}>
    <div className="relative">
      <div className="spot-halo absolute inset-0 -m-6" />
      <Spot variant="walk" eager animate={false} testId="spot-loader-img" className="spot-walk relative w-24 md:w-28 h-auto" alt="" />
      <div className="spot-shadow mx-auto mt-1" />
    </div>
    <div className="text-[#A8A39D] text-xs tracking-[0.3em] uppercase flex items-center gap-1">
      {label}<span className="spot-dots" aria-hidden="true"><i>.</i><i>.</i><i>.</i></span>
    </div>
  </div>
);
